/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatrixCareHomeHealthCreatePatientInput
 */
export interface MatrixCareHomeHealthCreatePatientInput {
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    businessUnitId: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    businessUnitName: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    lineOfBusinessId: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    lineOfBusinessName: string;
    /**
     * MatrixCare LOB category, e.g. "Home Health" or "Hospice". Copy from the lookup response.
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    lineOfBusinessType: string;
    /**
     * Required for Hospice LOBs. Encodes 1 = first 90-day period, 2 = second 90-day period, 3+ = Nth 60-day recert.
     * @type {number}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    startingCertPeriod?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    facilityDischargeTypeId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    isShortStayAcuteHospital?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    forObservationOnly?: boolean;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    referralSourceId?: string;
    /**
     * M/D/YYYY
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    referralDate: string;
    /**
     * M/D/YYYY
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    scheduledSocDate?: string;
    /**
     * M/D/YYYY
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    physicianOrderedSocDate?: string;
    /**
     * M/D/YYYY
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    facilityDischargeDate?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    middleName?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    suffix?: string;
    /**
     * 9 digits, no hyphens.
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    ssn?: string;
    /**
     * M/D/YYYY
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    dateOfBirth?: string;
    /**
     * 
     * @type {number}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    age?: number;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    nickname?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    preferredPronouns?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    raceId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    ethnicityId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    genderId: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    maritalStatusId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    livesAloneId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    sexualOrientationId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    genderIdentityId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    religionId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    homePhone?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    mobilePhone?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof MatrixCareHomeHealthCreatePatientInput
     */
    notifications?: string;
}

/**
 * Check if a given object implements the MatrixCareHomeHealthCreatePatientInput interface.
 */
export function instanceOfMatrixCareHomeHealthCreatePatientInput(value: object): value is MatrixCareHomeHealthCreatePatientInput {
    if (!('businessUnitId' in value) || value['businessUnitId'] === undefined) return false;
    if (!('businessUnitName' in value) || value['businessUnitName'] === undefined) return false;
    if (!('lineOfBusinessId' in value) || value['lineOfBusinessId'] === undefined) return false;
    if (!('lineOfBusinessName' in value) || value['lineOfBusinessName'] === undefined) return false;
    if (!('lineOfBusinessType' in value) || value['lineOfBusinessType'] === undefined) return false;
    if (!('referralDate' in value) || value['referralDate'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('genderId' in value) || value['genderId'] === undefined) return false;
    return true;
}

export function MatrixCareHomeHealthCreatePatientInputFromJSON(json: any): MatrixCareHomeHealthCreatePatientInput {
    return MatrixCareHomeHealthCreatePatientInputFromJSONTyped(json, false);
}

export function MatrixCareHomeHealthCreatePatientInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatrixCareHomeHealthCreatePatientInput {
    if (json == null) {
        return json;
    }
    return {
        
        'businessUnitId': json['businessUnitId'],
        'businessUnitName': json['businessUnitName'],
        'lineOfBusinessId': json['lineOfBusinessId'],
        'lineOfBusinessName': json['lineOfBusinessName'],
        'lineOfBusinessType': json['lineOfBusinessType'],
        'startingCertPeriod': json['startingCertPeriod'] == null ? undefined : json['startingCertPeriod'],
        'facilityDischargeTypeId': json['facilityDischargeTypeId'] == null ? undefined : json['facilityDischargeTypeId'],
        'isShortStayAcuteHospital': json['isShortStayAcuteHospital'] == null ? undefined : json['isShortStayAcuteHospital'],
        'forObservationOnly': json['forObservationOnly'] == null ? undefined : json['forObservationOnly'],
        'referralSourceId': json['referralSourceId'] == null ? undefined : json['referralSourceId'],
        'referralDate': json['referralDate'],
        'scheduledSocDate': json['scheduledSocDate'] == null ? undefined : json['scheduledSocDate'],
        'physicianOrderedSocDate': json['physicianOrderedSocDate'] == null ? undefined : json['physicianOrderedSocDate'],
        'facilityDischargeDate': json['facilityDischargeDate'] == null ? undefined : json['facilityDischargeDate'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'suffix': json['suffix'] == null ? undefined : json['suffix'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'dateOfBirth': json['dateOfBirth'] == null ? undefined : json['dateOfBirth'],
        'age': json['age'] == null ? undefined : json['age'],
        'nickname': json['nickname'] == null ? undefined : json['nickname'],
        'preferredPronouns': json['preferredPronouns'] == null ? undefined : json['preferredPronouns'],
        'raceId': json['raceId'] == null ? undefined : json['raceId'],
        'ethnicityId': json['ethnicityId'] == null ? undefined : json['ethnicityId'],
        'genderId': json['genderId'],
        'maritalStatusId': json['maritalStatusId'] == null ? undefined : json['maritalStatusId'],
        'livesAloneId': json['livesAloneId'] == null ? undefined : json['livesAloneId'],
        'sexualOrientationId': json['sexualOrientationId'] == null ? undefined : json['sexualOrientationId'],
        'genderIdentityId': json['genderIdentityId'] == null ? undefined : json['genderIdentityId'],
        'religionId': json['religionId'] == null ? undefined : json['religionId'],
        'homePhone': json['homePhone'] == null ? undefined : json['homePhone'],
        'mobilePhone': json['mobilePhone'] == null ? undefined : json['mobilePhone'],
        'email': json['email'] == null ? undefined : json['email'],
        'notifications': json['notifications'] == null ? undefined : json['notifications'],
    };
}

export function MatrixCareHomeHealthCreatePatientInputToJSON(json: any): MatrixCareHomeHealthCreatePatientInput {
    return MatrixCareHomeHealthCreatePatientInputToJSONTyped(json, false);
}

export function MatrixCareHomeHealthCreatePatientInputToJSONTyped(value?: MatrixCareHomeHealthCreatePatientInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'businessUnitId': value['businessUnitId'],
        'businessUnitName': value['businessUnitName'],
        'lineOfBusinessId': value['lineOfBusinessId'],
        'lineOfBusinessName': value['lineOfBusinessName'],
        'lineOfBusinessType': value['lineOfBusinessType'],
        'startingCertPeriod': value['startingCertPeriod'],
        'facilityDischargeTypeId': value['facilityDischargeTypeId'],
        'isShortStayAcuteHospital': value['isShortStayAcuteHospital'],
        'forObservationOnly': value['forObservationOnly'],
        'referralSourceId': value['referralSourceId'],
        'referralDate': value['referralDate'],
        'scheduledSocDate': value['scheduledSocDate'],
        'physicianOrderedSocDate': value['physicianOrderedSocDate'],
        'facilityDischargeDate': value['facilityDischargeDate'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'suffix': value['suffix'],
        'ssn': value['ssn'],
        'dateOfBirth': value['dateOfBirth'],
        'age': value['age'],
        'nickname': value['nickname'],
        'preferredPronouns': value['preferredPronouns'],
        'raceId': value['raceId'],
        'ethnicityId': value['ethnicityId'],
        'genderId': value['genderId'],
        'maritalStatusId': value['maritalStatusId'],
        'livesAloneId': value['livesAloneId'],
        'sexualOrientationId': value['sexualOrientationId'],
        'genderIdentityId': value['genderIdentityId'],
        'religionId': value['religionId'],
        'homePhone': value['homePhone'],
        'mobilePhone': value['mobilePhone'],
        'email': value['email'],
        'notifications': value['notifications'],
    };
}

